var React = require('react');

function Whatsapp (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .cls-1{fill-rule:evenodd;}\n    ")),React.createElement("path",{"className":"cls-1","d":"M50 86a41.93 41.93 0 0 1-11.9-1.71C28.26 90 14 90 14 90a18.11 18.11 0 0 0 8.42-14.52A37 37 0 0 1 10 48c0-21 17.91-38 40-38s40 17 40 38-17.91 38-40 38zm0-72c-19.88 0-36 15.22-36 34a33.09 33.09 0 0 0 12 25.29V76c0 6-2 8-2 8s2.74 0 8-2a19.72 19.72 0 0 0 4.62-2.45A37.71 37.71 0 0 0 50 82c19.88 0 36-15.22 36-34S69.88 14 50 14zm16 36H34a2 2 0 0 1 0-4h32a2 2 0 0 1 0 4zm0-8H34a2 2 0 0 1 0-4h32a2 2 0 0 1 0 4zM34 54h20a2 2 0 0 1 0 4H34a2 2 0 0 1 0-4z","key":1})]);
}

Whatsapp.defaultProps = {"width":"30","height":"25","data-name":"Layer 1","viewBox":"0 -15 100 125"};

module.exports = Whatsapp;

Whatsapp.default = Whatsapp;
